<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">Announce Release</span>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-half">
                                <b-field label="Status">
                                    <b-select expanded v-model="data.status">
                                        <option :value="null">Please Select</option>
                                        <option
                                            v-for="(status, index) in statuses"
                                            :key="index"
                                            :value="status"
                                        >{{ status.toUpperCase() }}</option>
                                    </b-select>
                                </b-field>
                                <b-field label="App" v-show="apps.length>1">
                                    <app-filter v-model="data.app_id" expanded></app-filter>
                                </b-field>

                                <b-field label="Name">
                                    <b-input v-model="data.name"></b-input>
                                </b-field>

                                <label class="label">Expected Test Date</label>
                                <div class="field is-grouped">
                                    <b-datepicker
                                        placeholder="Select Start Date"
                                        editable
                                        icon="calendar-today"
                                        v-model="expectedTestDate"
                                        expanded
                                    ></b-datepicker>
                                    <b-timepicker
                                        placeholder="Type or Select a Time"
                                        icon="clock"
                                        v-model="expectedTestTime"
                                        editable
                                        expanded
                                    ></b-timepicker>
                                </div>

                                <label class="label">Expected Release Date</label>
                                <div class="field is-grouped">
                                    <b-datepicker
                                        placeholder="Select Start Date"
                                        editable
                                        icon="calendar-today"
                                        v-model="releaseTestDate"
                                        expanded
                                    ></b-datepicker>
                                    <b-timepicker
                                        placeholder="Type or Select a Time"
                                        icon="clock"
                                        v-model="releaseTestTime"
                                        editable
                                        expanded
                                    ></b-timepicker>
                                </div>

                                <b-field label="Details">
                                    <b-input type="textarea" v-model="data.details"></b-input>
                                </b-field>

                                <section class="m-t-md">
                                    <b-button
                                        type="is-default m-r-sm"
                                        @click.prevent="goBack()"
                                    >Cancel</b-button>
                                    <b-button type="is-success m-r-sm" @click.prevent="create">Save</b-button>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _ from 'lodash/lodash';
import Cookies from '../../../helpers/cookies';
import AppFilter from '../../../components/AppFilter.vue'

export default {
    components:{
        AppFilter
    },
    data() {
        return {
            data: {
                status: null,
                name: null,
                details: null,
                app_id: null
            },
            apps:[],
            statuses: ["pending", "deployed", "void"],
            expectedTestDate: null,
            expectedTestTime: null,
            releaseTestDate: null,
            releaseTestTime: null
        };
    },
    computed: {
        referrer() {
            return Cookies.getCookie('referrer')
        }
    },
    mounted() {
        this.getAppList();
    },
    methods: {
        getAppList() {
            
            Vue.$appService.appList().then((response)=>{
                this.apps = response
                if(this.referrer!==''){
                    let referrer = this.referrer
                    let app = _.find(this.apps,(value)=>{
                        return referrer===value.href
                    })
                    if(app){
                        this.data.app_id = app.text
                    }
                }
                this.loading = false;
            });
        },
        create() {
            let data = {
                status: this.data.status,
                name: this.data.name,
                details: this.data.details,
                expected_test_date: this.formatExpectedTestDate(),
                expected_release_date: this.formatReleaseTestDate(),
                app_id: this.data.app_id
            };
            Vue.$releaseService.createRelease(data).then(() => {
                this.$buefy.toast.open({
                    message:"Release saved!",
                    type:'is-success',
                    queue:false
                });
                this.$router.push({
                    name: "releases"
                });
            });
        },
        goBack() {
            this.$store.commit("SET_ERRORS", null);
            this.$router.push({
                name: "releases"
            });
        },

        formatExpectedTestDate() {
            if (this.expectedTestDate && this.expectedTestTime) {
                let date =
                    moment(this.expectedTestDate).format("YYYY-MM-DD") +
                    " " +
                    moment(this.expectedTestTime).format("HH:mm");

                return date;
            }
            return null;
        },

        formatReleaseTestDate() {
            if (this.releaseTestDate && this.releaseTestTime) {
                let date =
                    moment(this.releaseTestDate).format("YYYY-MM-DD") +
                    " " +
                    moment(this.releaseTestTime).format("HH:mm");

                return date;
            }
            return null;
        }
    }
};
</script>